<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44.261"
    height="35.409"
    viewBox="0 0 44.261 35.409"
  >
    <path
      id="truck-solid"
      d="M43.155,24.344H42.048V16.868a3.32,3.32,0,0,0-.975-2.344L34.164,7.614a3.32,3.32,0,0,0-2.344-.975H28.77V3.32A3.32,3.32,0,0,0,25.45,0H3.32A3.32,3.32,0,0,0,0,3.32V25.45a3.32,3.32,0,0,0,3.32,3.32H4.426a6.639,6.639,0,0,0,13.278,0h8.852a6.639,6.639,0,0,0,13.278,0h3.32a1.11,1.11,0,0,0,1.107-1.107V25.45A1.11,1.11,0,0,0,43.155,24.344ZM11.065,32.09a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,11.065,32.09Zm22.131,0a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,33.2,32.09ZM38.729,17.7H28.77V9.959h3.05l6.909,6.909Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconCar',
  }
</script>
